import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'timeFormat' })
export class TimeFormatPipe implements PipeTransform {
    transform(value: string, args: string[]): any {
        if (!value) { return value; }

        return value.slice(0, 5);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/pipes/time-format.pipe.ts